<template>
  <InfiniteScroll @reached="fetchUsersRank" :is-loading="isLoading">
    <slot v-bind="{ users, isLoading }"/>
  </InfiniteScroll>
</template>

<script>
import { getUsersRank } from '@/api/user.api'
import InfiniteScroll from '@/components/layout/InfiniteScroll'

export default {
  components: {
    InfiniteScroll,
  },

  data: () => ({
    users: [],
    page: 1,
    isLoading: false
  }),

  methods: {
    async fetchUsersRank () {
      this.isLoading = true

      const res = await getUsersRank({  page: this.page++ })

      res.data.data.forEach(user => this.users.push(user))

      this.isLoading = false
    }
  }
}
</script>
